import { CuerpoLayout } from '@/components/oposiciones/CuerpoLayout';

export function BaseComunLayout() {
  return (
    <CuerpoLayout
      basePath="/app/base-comun"
      shortLabel="Base Común"
      accent="amber"
      areaId="generico"
      downloadsMode="base_comun"
      caseLabel="Supuestos"
    />
  );
}
